import { faArrowCircleLeft, faArrowCircleRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useMemo, useState } from 'react'
import { useMobileRecordContext } from "../../../contexts/mobileRecordContext"
import { sortFields } from "../../../utilities/mobileRecordHelper"
import HorizontalEntry from "./horizontalEntry"

const RootRecord = ({ children }) => {
  const [showBoreholeDetails, setShowBoreholeDetails] = useState(false)
  const { rootRecord, formTemplates, mobileGisPdfTemplates } = useMobileRecordContext()

  const formTemplate = useMemo(() => formTemplates[rootRecord.form_record_type], [rootRecord, formTemplates])
  const sortedFormFields = useMemo(() => sortFields(formTemplate), [formTemplate])

  const matchedTemplates = useMemo(
    () =>
      mobileGisPdfTemplates?.filter(
        (template) => template.form_id === formTemplate?.id
      ) ?? [],
    [mobileGisPdfTemplates, formTemplate]
  )

  const fieldObj = (mobileGisPdfTemplate) => {
    return {
      label: mobileGisPdfTemplate.name,
      data_type: 'gis_report',
      recordId: rootRecord.id
    }
  }

  return (<>
    <div className='flex-row bg-gray-200 flex'>
      {showBoreholeDetails && <div className='flex flex-col w-full gap-y-4 p-2'>
        {matchedTemplates && matchedTemplates.map(mobileGisPdfTemplate => (
          <HorizontalEntry key={mobileGisPdfTemplate.id} report={mobileGisPdfTemplate} field={fieldObj(mobileGisPdfTemplate)} />))}
        {sortedFormFields.map(field => (field.name !== 'boreholeId') && (
          <HorizontalEntry key={`${rootRecord.uuid}-${field.id}`} field={field} map={[]} />
        ))}
      </div>}
      <div className='w-8 items-center flex flex-col hover:bg-gray-200 p-2 cursor-pointer gap-2'
        onClick={() => setShowBoreholeDetails(!showBoreholeDetails)}>
        <FontAwesomeIcon icon={showBoreholeDetails ? faArrowCircleLeft : faArrowCircleRight} size='lg' />
        <p className='uppercase whitespace-nowrap leading-none' style={{ writingMode: 'vertical-lr' }}>
          {formTemplate?.name}
        </p>
      </div>
    </div>
    {children}
  </>
  )
}

export default RootRecord
